// repo: https://vuemc.io/#basic-usage
import {Model, Collection} from 'vue-mc'
import isPresent from 'is-present'
import Moment from 'moment-timezone'

class Addon extends Model {
  defaults() {
    return {
      id:   null,
      name: "",
      automatically_applied: false,
      archived: false,
      eligibility_required: false,
      currency: null,
      active_dates: true, //TODO: calculate whatever
      spaces: null,
      registrations_count: null,
    }
  }
  mutations() {
    return {
      id:   (id) => Number(id) || null,
      eligibility_required: (val) => !!val,
      currency: ()=>{
        if (this.pricing_type === 'no_price') return '';
        return this.pricing_type === 'fixed' ? '$' : '%'
      },
    }
  }

  isPersisted(){
    return !!this.id
  }
  isBlank(){
    return !this.isPersisted()
  }

  not_archived(){
    return !this.archived
  }
  activeDates(){
    return !this.active_dates
  }

  has_spaces(){
    if (!this.id) return true
    return this.spaces === null || this.spaces > this.registrations_count
  }
  no_spaces(){
    return !this.has_spaces()
  }
}

export {
  Addon
}
